// 登录判定弹窗
import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom"
import { Button } from 'antd-mobile'
import { ConditionLoading } from 'components/conditionLoading'
import { ConditionCheckList } from './ConditionCheckList'
import { getPersonalDetail, cancelDetailRequest } from 'api/api'
import { TRUE_FLAG_NUM, FALSE_FLAG_NUM, OTHER_NUM } from 'utils/constant'
import "static/css/serviceApply.css"
// import { UserContext } from "utils/getContext";

export const ConditionCheck = (props) => {
  // 从路由state中获取item
  const { state } = useLocation()
  const { item } = state || {}
  const navigate = useNavigate()
  // const { userInfo } = useContext(UserContext)
  // 事项列表
  const [list, setList] = useState([])
  // 所有事项列表
  const [allList, setAllList] = useState({})

  /**根据事项id获取事项列表的方法 */
  const getApplyList = useCallback(async (id) => {
    if (allList[id]) {
      setList(allList[id])
      return
    }
    const data = await getPersonalDetail(id)
    // 根据ftype拆分requirements，分为两个数组
    const requirements = data.requirements
    const systemConditions = []
    const personalConditions = []
    const otherConditions = []
    requirements.forEach(item => {
      const { type, ftype } = item
      // 处理item，符合表格的数据格式
      const newItem = {
        ...item,
        key: item.id
      }
      if (type === TRUE_FLAG_NUM && ftype === TRUE_FLAG_NUM) {
        systemConditions.push(newItem)
      } else if (type === TRUE_FLAG_NUM && ftype === OTHER_NUM) {
        personalConditions.push(newItem)
      } else {
        otherConditions.push(newItem)
      }
    })
    const newDetailList = [
      {
        name: data.name,
        fobject: data.object,
        furl: data.url,
        fitem: data.item,
        ftype: data.openType,
        systemConditions,
        personalConditions,
        otherConditions
      }
    ]
    setList(newDetailList)
    setAllList({
      ...allList,
      [id]: newDetailList
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item])


  // 根据item获取title
  const title = useMemo(() => {
    return item ? item.name : ''
  }, [item])


  // 根据item获取事项列表
  useEffect(() => {
    if (item) {
      const id = item.id
      if (allList[id]) {
        setList(allList[id])
      } else {
        getApplyList(id)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item])

  /**处理选择框点击改变值*/
  const handleSwitchChange = (value, listItem, type) => {
    // 根据type，修改对应的数组
    const newRequirements = list[0]
    const listValue = value ? TRUE_FLAG_NUM : FALSE_FLAG_NUM
    newRequirements[`${type}`] = newRequirements[`${type}`].map(item => {
      if (item.id === listItem.id) {
        item.value = listValue
      }
      return item
    })
    setList([newRequirements])
  }

  /**判定是否禁用 */
  const handleDisabled = useCallback(() => {
    if (list.length === 0) return true
    const { id } = item
    // 只有系统判断条件、个人判断条件全部为是，人员类别判断其中有一项为是，才允许点击立即申请
    const { systemConditions, personalConditions, otherConditions } = list[0]
    //如果systemConditions中的value全部为1，则显示
    const systemDisabled = systemConditions.length
      ?
      systemConditions.every(item => item.value === TRUE_FLAG_NUM)
      :
      true
    // 如果personalConditions中的value有一个为0,则显示
    const personalDisabled = personalConditions.length
      ?
      personalConditions.every(item => item.value === TRUE_FLAG_NUM)
      :
      true
    //  如果otherConditions中的value有一个为1,则显示
    const otherDisabled = otherConditions.length
      ?
      otherConditions.some(item => item.value === TRUE_FLAG_NUM)
      :
      true
    // 这步目前在外面额外判断
    // 对用户type和fobject进行判断,一致才允许进入
    // const userType = userInfo.USER_TYPE === fobject ? true : false
    // 失业和就业额外判定，默认允许通过
    const isSpecial = id === 8 || id === 9 ? true : false
    const disabled = systemDisabled && personalDisabled && otherDisabled
    return isSpecial ? !isSpecial : !disabled
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list])

  /**返回 */
  const handleBack = () => {
    navigate(-1)
  }

  /**返回首页 */
  const handleBackHome = () => {
    navigate('/home')
  }

  /**立即申请 */
  const handleApplication = useCallback(() => {
    handleNavigate(item)
    /**处理即将跳转的页面 */
    function handleNavigate(item) {
      const url = item?.furlh5 || item?.furl
      const navigateType = item?.ftype === TRUE_FLAG_NUM
      if (navigateType) {
        if (url === '/subsidy') {
          const newUrl = '/newSubsidy'
          navigate(newUrl)
        } else if (url === '/affirmEmploy') {
          const newUrl = '/newAffirmEmploy'
          navigate(newUrl)
        } else {
          navigate(url)
        }
      } else {
        window.location.href = item?.furl
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item])

  // 离开页面时取消请求
  useEffect(() => {
    return () => {
      cancelDetailRequest && cancelDetailRequest('请求取消');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  /**
   * 跳转到办事指南  暂未移植 
   */
  // const toGuide = () => {
  //   const id = list[0].fitem
  //   if (id) {
  //     handleCancel()
  //     navigate('/service', { state: { id: id } })
  //   } else {
  //     message.info('暂无办事指南')
  //   }
  // }

  if (!item) {
    return <Button onClick={handleBackHome}>返回首页</Button>
  }

  return (
    // 表单页面
    <div className="service-apply">
      {/* 表头 */}
      <div className="service-apply-title">
        <p>{title}</p>
      </div>
      {/* 内容 */}
      <div className="service-apply-content">
        {
          list.length > 0
            ?
            (
              <div>
                <p className="service-apply-secTitle">
                  此政策需满足以下条件：
                </p>
                <div className="service-apply-list">
                  <ConditionCheckList list={list} onItemChange={handleSwitchChange} />
                </div>
              </div>
            )
            :
            (
              <ConditionLoading />
            )
        }
      </div>
      <div className="service-apply-button">
        {/* 暂未移植 */}
        {/* {
          list.length > 0 && list[0].fitem &&
          <p className='detail-list-footer'>
            更多办件信息请查看<a onClick={toGuide}>办事指南</a>
          </p>
        } */}
        <Button
          className='service-apply-button-back'
          onClick={handleBack}>
          返回服务
        </Button>
        {
          list.length > 0 &&
          <Button
            className='service-apply-button-apply'
            disabled={handleDisabled()}
            onClick={handleApplication}
          >
            立即申请
          </Button>
        }
      </div>
    </div >
  )
}